import React from "react";
import { AnimatePresence, motion } from "framer-motion";

const fadeVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 1, ease: "easeOut" } },
  exit: { opacity: 0, transition: { duration:1, ease: "easeIn" } },
};
const PageWrapper = ({ children }) => (
 <AnimatePresence mode="wait">
  <motion.div
    variants={fadeVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    {children}
  </motion.div>
  </AnimatePresence>
);

export default PageWrapper;
